export default function(ob: any): any {
  return JSON.parse(JSON.stringify(ob));
}
